import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09013cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "주소 입력", -1))
const _hoisted_6 = { class: "content_wrapper" }
const _hoisted_7 = { class: "wrap" }
const _hoisted_8 = { class: "wrap_top" }
const _hoisted_9 = { class: "addr_box" }
const _hoisted_10 = { class: "input_box" }
const _hoisted_11 = {
  id: "jibunAddr",
  class: "jibun_addr"
}
const _hoisted_12 = { class: "input_box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "road_badge" }, " 도로명 ", -1))
const _hoisted_14 = {
  id: "roadAddr",
  class: "road_addr"
}
const _hoisted_15 = { class: "detail_addr" }
const _hoisted_16 = { class: "wrap_bottom" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-address",
  class: "modal-address"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "popup-wrap",
    class: "popup-wrap"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_input = _resolveComponent("ion-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'취소'}); _ctx.dismiss()})
        }, "취소")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.jibunAddress), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.roadAddress), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_ion_input, {
                modelValue: _ctx.extraAddress,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.extraAddress) = $event)),
                class: "detail_input",
                type: "text",
                placeholder: "상세주소 (아파트 / 동 / 호)"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "addr_btn",
              disabled: !_ctx.extraAddress,
              style: _normalizeStyle(_ctx.extraAddress == '' ? { opacity: 0.3 } : ''),
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'완료'}); _ctx.success()})
            }, " 완료 ", 12, _hoisted_17)
          ])
        ], 512), [
          [_vShow, _ctx.roadAddress !== '' || _ctx.jibunAddress !== '']
        ]),
        _hoisted_18
      ])
    ])
  ]))
}